module.exports = ""


//////////////////
// WEBPACK FOOTER
// /var/www/borneo/prod/borneo_app/src/app/shared/components/tables/sortable-table/column/column.component.html
// module id = ../../../../../src/app/shared/components/tables/sortable-table/column/column.component.html
// module chunks = main